import { CNavLink } from '../CNavLink';
import { useActiveLeague } from '../../hooks/useActiveLeague';

function TeamPageNav({id}) {
  const { activeLeague } = useActiveLeague();

  return (
      <div className="onpage-nav-block">
          <ul className="onpage-nav">
              <CNavLink to={activeLeague ? `/${activeLeague.slug}/team-pitch/${id}` : '#'} active={['team-pitch']}>
                  Pitch
              </CNavLink>
              <CNavLink to={activeLeague ? `/${activeLeague.slug}/team-list/${id}` : '#'} active={['team-list']}>
                  List
              </CNavLink>
          </ul>

      </div>
  )
}

export {TeamPageNav}
